import React from "react";
import { motion } from "framer-motion";

const services = [
    { name: "Consultation", price: "₹ 1", note: "The founding promise" },
    { name: "Blood Pressure Check", price: "₹ 1", note: "Walk-in, no appointment" },
    { name: "Blood Sugar Test", price: "₹ 10", note: "Instant glucometer reading" },
    { name: "ECG", price: "₹ 100", note: "On-site cardiac diagnostics" },
    { name: "Injection", price: "₹ 30", note: "Prescribed by clinic physician" },
    { name: "Nebulizer", price: "₹ 100", note: "Respiratory emergencies" },
    { name: "Wound Dressing", price: "₹ 50", note: "Including post-trauma care" },
    { name: "Sutures", price: "₹ 100", note: "Minor surgical interventions" },
    { name: "CBC", price: "₹ 100", note: "Complete blood count · Kamal Pathology Lab" },
    { name: "Malaria · Bilirubin · Calcium · Creatinine", price: "₹ 100", note: "Same-day reporting" },
    { name: "Pharmacy — Kamal Pharma", price: "~50% off", note: "Branded & generic medicines" },
    { name: "Emergency Stabilisation", price: "Free", note: "Golden Hour interventions" },
];

const Services = () => {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-24 md:py-32 lg:py-40 bg-sky-tint border-y border-ink-900/8"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8">
                    <div className="col-span-12 lg:col-span-4">
                        <div className="section-number">05 / Services</div>
                        <div className="mt-6 divider" />
                        <div className="mt-4 eyebrow">The Rate Card</div>
                    </div>

                    <div className="col-span-12 lg:col-span-8">
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                            className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink-900 max-w-3xl"
                        >
                            A menu written in <em className="text-clinicgreen-deep">single digits</em> —
                            so dignity stays intact at the counter.
                        </motion.h2>
                        <p className="mt-6 font-body text-base md:text-lg text-ink-700 max-w-2xl leading-relaxed">
                            Every clinic carries the same printed rate card. No surprises,
                            no hidden charges, no negotiation. Posted on the wall — readable
                            from across the platform.
                        </p>
                    </div>
                </div>

                <div className="mt-16 md:mt-20 bg-paper-50 border border-ink-900/10">
                    {services.map((s, i) => (
                        <motion.div
                            key={s.name}
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.8, delay: i * 0.04, ease: [0.22, 1, 0.36, 1] }}
                            className="group grid grid-cols-12 gap-4 items-center py-6 px-6 md:px-8 border-b border-ink-900/8 last:border-b-0 hover:bg-bisleri-light/40 transition-colors"
                            data-testid={`service-row-${i}`}
                        >
                            <div className="col-span-1 font-mono text-[11px] text-ink-500 group-hover:text-bisleri transition-colors">
                                {String(i + 1).padStart(2, "0")}
                            </div>
                            <div className="col-span-7 md:col-span-6">
                                <div className="font-display text-xl md:text-2xl text-ink-900">
                                    {s.name}
                                </div>
                                <div className="mt-1 font-body text-xs md:text-sm text-ink-600">
                                    {s.note}
                                </div>
                            </div>
                            <div className="col-span-4 md:col-span-5 text-right">
                                <span className={`font-display text-2xl md:text-3xl tabular-nums ${
                                    s.price === "Free" ? "text-clinicgreen-deep" : "text-bisleri"
                                }`}>
                                    {s.price}
                                </span>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
